import { DwAction, DwActionHandler, DwActionItemRequirement, DwActionResult, DwActionState, DwActionType, DwButtonType, DwGridActionKeys, DwGridActionResult, DwGridMultiEditConfig, DwGridMultiEditConfigComponent, DwMdFormActionState, DwMdPdfResult, DwMetaDataGridActionState, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize, DwReportingService, DwReportingServiceToken, ensureArray } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { PerformanceManagementMetaDataItemNames } from '../meta-data/performancemanagement-meta-data.service';
import { EmployeeReviewKickoffModalComponent } from '../components/employee-review-kickoff-modal/employee-review-kickoff-modal.component';
import { map } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { EmployeeReviewKickoffModalArgs } from '../models/emplyoee-review-kickoff-modal-args.model';
import { EmployeeReviewKickoffModalResult } from '../models/employee-review-kickoff-modal-result.model';

@DwAction({
    keyName: 'employeeReviewPrint',
    display: 'Employee Review Print',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [PerformanceManagementMetaDataItemNames.EmployeeReviewSummary, PerformanceManagementMetaDataItemNames.EmployeeReview],
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Export to PDF',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-primary',
        iconClass: 'fa fa-file-pdf dw-red',
    },
    defaultSecurityConfig: {
    },
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: 'Exporting to PDF...',
    }
})
@Injectable()
export class EmployeeReviewPrintActionService implements DwActionHandler {
    constructor(
        private dwModalService: DwModalService,
        @Inject(DwReportingServiceToken) protected dwReportingService: DwReportingService,
    ) { }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {


        return actionState.formApi.getPrintableHtml()
            .pipe(map(html => {
                //this.printHtmlWithBrowser(html);

                this.printHtmlToPdf(html);

                return { success: true };
            }));


        // use the standard browser print
        // window.print(); 

        // return of({ success: true });
    }


    printHtmlWithBrowser(html: string) {

        const finalBodyHtml = this.tweakReviewHtmlForPageBreaks(html);

        var mywindow = window.open('', 'PRINT', 'height=900,width=1200');

        mywindow.document.write('<html><head><title>Print</title>');
        mywindow.document.write('<link rel="stylesheet" href="http://localhost:4200/styles.css">');
        
        mywindow.document.write('</head><body style="background-color:white">');
        mywindow.document.write('<div class="dw-form-print">');
        mywindow.document.write(finalBodyHtml);
        mywindow.document.write('</div>');
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        // Wait 200ms for styles to load
        setTimeout(() => {
            // mywindow.print();
            // mywindow.close();
        }, 200);
    }

    printHtmlToPdf(html: string) {
        const finalBodyHtml = '<div class="dw-form-print">' +this.tweakReviewHtmlForPageBreaks(html) + '</div>';

        this.dwReportingService.convertHtmlToPdf(finalBodyHtml, 1, 'Employee-Review.pdf', true)
        .subscribe(result => {
            const newResult: DwMdPdfResult = {
                Base64Data: result.Base64Data,
                FileName: result.FileName,
                Html: finalBodyHtml
            }

            this.dwReportingService.saveExportAsFile(result, 'employee-review.pdf');
        });

    }



    tweakReviewHtmlForPageBreaks(html: string) {

        // const startIndex=  html.indexOf('page-container');
        // const endIndex=  html.indexOf('end-page-container');

        const startIndex = this.findStartDiv(html, 'page-container');
        const stopIndex = this.findStartDiv(html, 'end-page-container');

        const evalSection = html.substring(startIndex, stopIndex);

        html = html.replace(evalSection,'');

        return html + evalSection;
    }

    findStartDiv(html: string, tagName: string):number {
        const index1 = html.indexOf(tagName);

        return html.lastIndexOf('<div', index1);
    }

}